import {
  ActionButtonContainer,
  ActionButton,
} from "components/AgGrid/ActionButton";

import React from "react";

import {
  faDownload,
  faEye,
  faEyeSlash,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { SideLoadedBusinessGridContext } from "components/Business/SideLoadedBusinesses/useSideLoadedBusinessGridContext";

interface SideLoadedBusinessActionsRendererProps {
  context: SideLoadedBusinessGridContext;
  data: SideLoadedBusiness;
}

export function SideLoadedBusinessActionsRenderer({
  context,
  data,
}: SideLoadedBusinessActionsRendererProps) {
  const { canIgnore, handleSelectAndCompare, handleSetIgnored } = context;
  const { id, isIgnored } = data;

  let ignoreTitle = isIgnored
    ? "Show this entry in suggestions again."
    : "Stop showing this entry in suggestions.";
  if (!canIgnore) {
    ignoreTitle = "You don't have permission to change this data set.";
  }

  return (
    <ActionButtonContainer>
      <ActionButton
        onClick={() => handleSelectAndCompare(id)}
        data-tour="selectAndCompare"
      >
        <FontAwesomeIcon icon={faDownload} />
        &nbsp;Use
      </ActionButton>
      <ActionButton
        onClick={() => handleSetIgnored(id, !isIgnored)}
        data-tour="ignoreSideLoadedBusiness"
        disabled={!canIgnore}
        title={ignoreTitle}
      >
        <FontAwesomeIcon icon={isIgnored ? faEye : faEyeSlash} />
        &nbsp;{isIgnored ? "Restore" : "Ignore"}
      </ActionButton>
    </ActionButtonContainer>
  );
}
